/**
 * 17-Oct-2022
 */

;(function ($) {
  'use strict';

  const theme = {

    /**
     * Theme's components/functions list
     * Comment out or delete the unnecessary component.
     * Some component have dependencies (plugins).
     * Do not forget to remove component plugin script from src/vendor/js
    */

    init: () => {
      theme.stickyNavbar();
      theme.stuckNavbarMenuToggle();
      theme.passwordVisibilityToggle();
      theme.formValidation();
      theme.multilevelDropdown();
      theme.scrollTopButton();
      theme.tooltips();
      theme.popovers();
      theme.toasts();
      theme.disableDropdownAutohide();
      theme.carousel();
      theme.gallery();
      theme.productGallery();
      theme.imageZoom();
    },

    /**
     * Enable sticky behaviour of navigation bar on page scroll
     * @memberof theme
     * @method stickyNavbar
    */
    stickyNavbar: () => {

      let navbar = document.querySelector('.navbar-sticky');

      if (navbar == null) return;

      let navbarH = navbar.offsetHeight,
          scrollOffset = 400;

      window.addEventListener('scroll', (e) => {
        if (e.currentTarget.pageYOffset > scrollOffset) {
          if (! navbar.classList.contains('navbar-transparent')) {
            document.body.style.paddingTop = navbarH + 'px';
          }
          navbar.classList.add('navbar-stuck');
        } else {
          document.body.style.paddingTop = '';
          navbar.classList.remove('navbar-stuck');
        }
      });
    },


    /**
     * Stuck 3 level navbar menu toggle
     * @memberof theme
     * @method stuckNavbarMenuToggle
    */
    stuckNavbarMenuToggle: () => {

      let toggler = document.querySelector('.navbar-stuck-toggler'),
          stuckMenu = document.querySelector('.navbar-stuck-menu');

      if (toggler == null) return;

      toggler.addEventListener('click', function (e) {
        stuckMenu.classList.toggle('show');
        e.preventDefault();
      });

    },


    /**
     * Toggling password visibility in password input
     * @memberof theme
     * @method passwordVisibilityToggle
    */
    passwordVisibilityToggle: () => {

      let elements = document.querySelectorAll('.password-toggle');

      for (let i = 0; i < elements.length; i++) {
        let passInput = elements[i].querySelector('.form-control'),
        passToggle = elements[i].querySelector('.password-toggle-btn');
    
        passToggle.addEventListener('click', (e) => {
          
          if (e.target.type !== 'checkbox') return;
          if (e.target.checked) {
            passInput.type = 'text';
          } else {
            passInput.type = 'password';
          }

        }, false);
      }
    },


    /**
     * From validation
     * @memberof theme
     * @method formValidation
    */
    formValidation: () => {

      let selector = 'needs-validation';

      window.addEventListener('load', () => {
        // Fetch all the forms we want to apply custom Bootstrap validation styles to
        let forms = document.getElementsByClassName(selector);
        // Loop over them and prevent submission
        let validation = Array.prototype.filter.call(forms, (form) => {
          form.addEventListener('submit', (e) => {
            if (form.checkValidity() === false) {
              e.preventDefault();
              e.stopPropagation();
            }
            form.classList.add('was-validated');
          }, false);
        });
      }, false);
    },


    /**
     * Multilevel dropdown
     * @memberof theme
     * @method multilevelDropdown
     * @requires https://jquery.com/
     * @requires https://getbootstrap.com
    */
    multilevelDropdown: function () {

      let selector = ".dropdown-menu [data-toggle='dropdown']";

      $(selector).on('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        $(this).siblings().toggleClass('show');

        if (!$(this).next().hasClass('show')) {
          $(this).parents('.dropdown-menu').first().find('.show').removeClass('show');
        }
        $(this).parents('li.nav-item.dropdown.show').on('hidden.bs.dropdown', function () {
          $('.dropdown-submenu .show').removeClass('show');
        });
      });
    },


    /**
     * Animate scroll to top button in/off view
     * @memberof theme
     * @method scrollTopButton
    */
    scrollTopButton: () => {

      let element = document.querySelector('.btn-scroll-top'),
          scrollOffset = 600;
      
      if (element == null) return;

      let offsetFromTop = parseInt(scrollOffset, 10);
      
      window.addEventListener('scroll', (e) => {
        if (e.currentTarget.pageYOffset > offsetFromTop) {
          element.classList.add('show');
        } else {
          element.classList.remove('show');
        }
      });
    },

    /**
     * Tooltips
     * @memberof theme
     * @method tooltips
     * @requires https://jquery.com/
     * @requires https://getbootstrap.com
     * @requires https://popper.js.org/
    */
    tooltips: () => {

      var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'));
      var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
        return new bootstrap.Tooltip(tooltipTriggerEl, {
        trigger: 'hover'
        });
      });
    },


    /**
     * Popovers
     * @memberof theme
     * @method popovers
     * @requires https://jquery.com/
     * @requires https://getbootstrap.com
     * @requires https://popper.js.org/
    */
    popovers: () => {

      var popoverTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]'));
      var popoverList = popoverTriggerList.map(function (popoverTriggerEl) {
        return new bootstrap.Popover(popoverTriggerEl);
      });
    },

    /**
     * Toasts
     * @param {string} selector
    */
    toasts: () => {

      let selector = $('[data-toggle="toast"]');

      selector.on('click', function() {
        var target = $(this).data('target');
        $(target).toast('show');
      });
    },


    /**
     * Disable dropdown autohide when select is clicked
     * @memberof theme
     * @method disableDropdownAutohide
    */
    disableDropdownAutohide: () => {

      let elements = document.querySelectorAll('.disable-autohide .custom-select');

      for (let i = 0; i < elements.length; i++) {
        elements[i].addEventListener('click', (e)=> {
          e.stopPropagation();
        });
      }
    },


    /**
     * Content carousel with extensive options to control behaviour and appearance
     * @memberof theme
     * @method carousel
     * @requires https://github.com/ganlanyuan/tiny-slider
    */
    carousel: () => {

      // forEach function
      let forEach = function (array, callback, scope) {
        for (let i = 0; i < array.length; i++) {
          callback.call(scope, i, array[i]); // passes back stuff we need
        }
      };
      
      // Carousel initialisation
      let carousels = document.querySelectorAll('.tns-carousel .tns-carousel-inner');
      forEach(carousels, function (index, value) {
        let defaults = {
          container: value,
          controlsText: ['<i class="bi bi-arrow-left"></i>', '<i class="bi bi-arrow-right"></i>'],
          navPosition: 'bottom',
          mouseDrag: true,
          speed: 500,
          autoplayHoverPause: true,
          autoplayButtonOutput: false
        };
        let userOptions;
        if(value.dataset.carouselOptions != undefined) userOptions = JSON.parse(value.dataset.carouselOptions);
        let options = {...defaults, ...userOptions};
        let carousel = tns(options);
      });
    },


    /**
     * Lightbox component for presenting various types of media
     * @memberof theme
     * @method gallery
     * @requires https://github.com/sachinchoolur/lightgallery.js
    */
    gallery: () => {

      let gallery = document.querySelectorAll('.kartooz-gallery');
      if (gallery.length) {
        for (let i = 0; i < gallery.length; i++) {
          lightGallery(gallery[i], {
            selector: '.gallery-item',
            download: false,
            videojs: true,
            youtubePlayerParams: {
              modestbranding: 1,
              showinfo: 0,
              rel: 0,
              controls: 0
            },
            vimeoPlayerParams: {
              byline: 0,
              portrait: 0,
              color: 'fe696a'
            }
          });
        }
      }
    },


    /**
     * Shop product page gallery with thumbnails
     * @memberof theme
     * @method productGallery
     * @requires https://github.com/sachinchoolur/lightgallery.js
    */
    productGallery: () => {

      let gallery = document.querySelectorAll('.kartooz-product-gallery');
      if (gallery.length) {

        for (let i = 0; i < gallery.length; i++) {
          
          let thumbnails = gallery[i].querySelectorAll('.kartooz-product-gallery-thumblist-item:not(.video-item)'),
              previews = gallery[i].querySelectorAll('.kartooz-product-gallery-preview-item'),
              videos = gallery[i].querySelectorAll('.kartooz-product-gallery-thumblist-item.video-item');


          for (let n = 0; n < thumbnails.length; n++) {
            thumbnails[n].addEventListener('click', changePreview);
          }

          // Changer preview function
          function changePreview(e) {
            e.preventDefault();
            for (let i = 0; i < thumbnails.length; i++) {
              previews[i].classList.remove('active');
              thumbnails[i].classList.remove('active');
            }
            this.classList.add('active');
            gallery[i].querySelector(this.getAttribute('href')).classList.add('active');
          }

          // Video thumbnail - open video in lightbox
          for (let m = 0; m < videos.length; m++) {
            lightGallery(videos[m], {
              selector: 'this',
              download: false,
              videojs: true,
              youtubePlayerParams: {
                modestbranding: 1,
                showinfo: 0,
                rel: 0,
                controls: 0
              },
              vimeoPlayerParams: {
                byline: 0,
                portrait: 0,
                color: 'fe696a'
              }
            });
          }
        }
      }
    },


    /**
     * Image zoom on hover (used inside Product Gallery)
     * @memberof theme
     * @method imageZoom
     * @requires https://github.com/imgix/drift
    */
    imageZoom: () => {
      
      let images = document.querySelectorAll('.kartooz-image-zoom');

      for (let i = 0; i < images.length; i++) {
        new Drift(images[i], {
          paneContainer: images[i].parentElement.querySelector('.kartooz-image-zoom-pane')
        });
      }
    }

  }

  /**
   * Init theme core
  */
  
  theme.init();

})(jQuery);